export class DashboardCardSelections {
  id: number;
  dashboard: string;
  cards: string;
  enteredBy: string;
  updatedAt: string;
}
